export default __webpack_public_path__ + "adobe-lightroom.739d3d04.png";